"use client";

import { useQuery } from "@tanstack/react-query";

import { useAuthSession } from "@lib/hooks/use-auth-session";

export function ActivityTracker() {
  const { data: session } = useAuthSession();

  useQuery({
    queryKey: ["activity-tracker", session?.user?.id],
    queryFn: async () => {
      const res = await fetch("/api/marketing/last-activity", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
      });

      if (!res.ok) {
        throw new Error("Failed to fetch last activity");
      }

      return res.json();
    },
    enabled: !!session?.user?.id,
    staleTime: 1000 * 60 * 60, // 1 hour
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    retry: 1,
  });

  return null;
}
